import DashInfoCard from './DashInfoCard';
export default DashInfoCard;
export { default as DashInfoCard } from './DashInfoCard';